import { render, staticRenderFns } from "./AddressVerifyChip.vue?vue&type=template&id=24c21f7c&"
import script from "./AddressVerifyChip.vue?vue&type=script&lang=js&"
export * from "./AddressVerifyChip.vue?vue&type=script&lang=js&"
import style0 from "./AddressVerifyChip.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports